export class GeneratePdfItineraryByText {
  public ItineraryTemplateId: number
  public ItineraryGenerated: string;
}
